import { combineReducers } from "redux";

import { usersDetails } from "./reducer.users"
const userReducers = combineReducers({

  usersDetails

})
export default userReducers;
